export enum AuthenticationState {
    AwaitingAuthentication = 'AWAITING_AUTHENTICATION',
    Authenticated = 'AUTHENTICATED',
    Unauthenticated = 'UNAUTHENTICATED',
}
